// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"583":"2e421c3f0285f19a","888":"e57a9fe69e817bb1"}[chunkId] + ".css";
};